import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  selectAll(event) {
    const target = event.target.dataset.target
    const checkboxes = document.querySelectorAll(`input[name="${target}[]"]`)
    checkboxes.forEach(checkbox => {
      checkbox.checked = true
    })
  }

  deselectAll(event) {
    const target = event.target.dataset.target
    const checkboxes = document.querySelectorAll(`input[name="${target}[]"]`)
    checkboxes.forEach(checkbox => {
      checkbox.checked = false
    })
  }
}
